<template>
    <card :title="$t('canvas')" full-flex class="h-100">
        <div class="row d-flex flex-grow-1">
            <div class="col-8 justify-content-center bg-light p-2 mt-neg-5">
                <div class="canvas bg-white" :style="{width: width,height: height}" ref="canvas">
                    <VueDragResize
                        v-if="sizeSet"
                        v-for="templatearea in template.templateareas"
                        :key="templatearea.name"
                        :w="templatearea.scaled_width" 
                        :h="templatearea.scaled_height" 
                        :x="templatearea.scaled_left"
                        :y="templatearea.scaled_top"
                        :z="templatearea.zIndex"
                        @dragging="setTemplateArea" 
                        @resizing="setTemplateArea" 
                        @activated="setActive(templatearea)"
                        :parentLimitation="true"
                        :isActive="templatearea.active"
                        ><span class="templatearea-title">{{ templatearea.name }}</span></VueDragResize>
                    <canvas ref="thumbnail" style="visibility: hidden"></canvas>
                </div>
            </div>
            <div class="col-4">
                <ul class="nav nav-tabs" id="templateTabs" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="template-info" data-toggle="tab" href="#info" role="tab" aria-controls="info" aria-selected="true">{{ $t('settings')}}</a>
                    </li>
                    <li v-if="!creating" class="nav-item">
                        <a class="nav-link" id="template-templateareas" data-toggle="tab" href="#templateareas" role="tab" aria-controls="templateareas" aria-selected="false">{{ $t('templateareas')}}</a>
                    </li>
                </ul>

                <div class="tab-content">
                    <div class="tab-pane fade show active" id="info" role="tabpanel" aria-labelledby="template-info">
                        <form class="my-3" @submit.prevent="register">
                            <div class="form-group">
                                <label for="">{{ $t('printabletype') }}</label>
                                <select name="printabletype_id" class="form-control" v-model="template.printable_type_id" @change="setPaperSize">
                                    <option value="">{{ $t('select_printabletype') }}</option>
                                    <option v-for="printabletype in printable_types" :key="printabletype.id" :value="printabletype.id">{{ printabletype.name }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="name">{{ $t('name') }}</label>
                                <input type="text" name="name" id="name" class="form-control" v-model="template.name">
                            </div>
                            <div class="form-group">
                                <label for="description">{{ $t('description') }}</label>
                                <textarea name="description" id="description" class="form-control" v-model="template.description"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="order">{{ $t('order') }}</label>
                                <input type="text" name="order" id="order" class="form-control" v-model="template.order">
                            </div>
                            <div class="form-group mt-3">
                                <div class="switch">
                                    <input type="checkbox" class="switch" name="fullpage_bleed" id="fullpage_bleed" v-model="template.fullpage_bleed">
                                    <label for="fullpage_bleed">{{ $t('fullpage_bleed') }}</label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="tab-pane fade" id="templateareas" role="tabpanel" aria-labelledby="template-templateareas">
                        <div class="text-right my-3">
                            <button class="btn btn-success" @click="createTemplateArea">
                                <fa :icon="['fal','plus']" />
                                {{ $t('add_new_templatearea') }}
                            </button>
                        </div>
                        <card v-for="templatearea in template.templateareas" v-if="templatearea.active"
                            :key="templatearea.id" :class="{'bg-active':templatearea.active}" class="mb-3">
                            <div class="form-group row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="">{{ $t('name') }}</label>
                                        <input type="text" name="name" :value="templatearea.name" @change="updateTemplateArea($event,templatearea.id)" class="form-control form-control-sm">
                                    </div>
                                </div>
                            
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="">{{ $t('top') }}</label>
                                        <input type="string" name="top" :value="templatearea.top" @change="updateTemplateArea($event,templatearea.id)" class="form-control form-control-sm">
                                    </div>
                                    <div class="form-group">
                                        <label for="">{{ $t('width') }}</label>
                                        <input type="text"  name="width" :value="templatearea.width" @change="updateTemplateArea($event,templatearea.id)" class="form-control form-control-sm">
                                    </div>
                                </div>

                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="">{{ $t('left') }}</label>
                                        <input type="text" name="left" :value="templatearea.left" @change="updateTemplateArea($event,templatearea.id)" class="form-control form-control-sm">
                                    </div>
                                    <div class="form-group">
                                        <label for="">{{ $t('height') }}</label>
                                        <input type="text" name="height" :value="templatearea.height" @change="updateTemplateArea($event,templatearea.id)" class="form-control form-control-sm">
                                    </div>
                                </div>
                                
                                <div class="col-6">
                                    <label for="">{{ $t('z_index') }}</label>
                                    <input type="text" name="zIndex" :value="templatearea.zIndex" @change="updateTemplateArea($event,templatearea.id)" class="form-control form-control-sm">
                                </div>

                                <div class="col">
                                    <div class="mt-4 text-right">
                                        <button class="btn btn-sm btn-danger" :title="$t('delete')" @click="deleteTemplateArea(templatearea)">
                                            <fa :icon="['fal','trash-alt']" fixed-width/>
                                            {{ $t('delete') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </div>
        <template slot="footer">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <router-link 
                        class="btn btn-outline-danger"
                        :to="{ path : '/admin/templates'}">Avbryt</router-link>
                </div>
                <div>
                    <button class="btn btn-info" @click="saveTemplate">
                        {{ $t('save') }}
                    </button>

                    <button class="btn btn-primary" @click="saveTemplate(true)">
                        {{  $t('save_close')  }}
                    </button>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import $ from 'jquery'
import Vue from 'vue'
import axios from "axios";
import VueDragResize from 'vue-drag-resize'

export default {
    components: {
        VueDragResize
    },
    data() {
        return {
            factor: 1,
            creating: false,
            width: 0,
            height: 0,
            format : 'landscape',
            sizeSet : false,
            printable_types: [],
            template : {
                printable_type : {
                    paper_height : 0,
                    paper_width: 0
                },
                name : '',
                description : '',
                order : 0,
                fullpage_bleed : false
            },
        };
    },
    computed: {
        ratio(){
            let pt = this.template.printable_type;
            return pt.paper_width / pt.paper_height
        }
    },
    created(){
        if(this.$route.params.id){
            this.fetchData(this.$route.params.id);
        } else {
            this.creating = true;
            this.fetchData();
        }
    },
    watch:{
        template(n,o){
            this.setSize();
        }
    },
    methods : {
        setSize(){
            let pt = this.template.printable_type;
            let el = this.$refs.canvas;
            let factor = 1;


            if(pt.paper_height > pt.paper_width){
                this.format = 'portrait';
                this.height = '100%';
                this.width = el.offsetHeight * (pt.paper_width / pt.paper_height) + 'px'
                
                factor = el.offsetHeight / pt.paper_height;
            } else {
                this.format = 'landscape';
                this.width = '100%';
                this.height = el.offsetWidth * (pt.paper_height / pt.paper_width) + 'px'

                factor = el.offsetWidth / pt.paper_width;

            }

            if(isFinite(factor)){
                this.factor = factor;
            }

            this.$nextTick(function(){
                this.sizeSet = true;

                if(el.offsetWidth < 10 || el.offsetHeight < 10){
                    this.setSize();
                } 
            });

            this.parseTemplateAreas();
        },
        setInactive(templatearea){            
           templatearea.active = false
           this.refresh();
        },
        setActive(templatearea){
            $.each(this.template.templateareas,function(i,c){
                if(c.active) c.active = false;
            });
            
           templatearea.active = true
           this.refresh();
        },
        getActive(){
            var ret = null;

            $.each(this.template.templateareas,function(i,c){
                if(c.active) ret = c;
            });

            return ret;
        },
        getTemplateArea(id){
            let ret = null;

            $.each(this.template.templateareas,function(i,c){
                if(c.id == id) ret = c;
            });

            return ret;
        },
        setTemplateArea(newTemplateArea){
            var comp = this.getActive();
            
            if(comp){
                let left = newTemplateArea.left >= 0 ? newTemplateArea.left : 0;
                let top = newTemplateArea.top >= 0 ? newTemplateArea.top : 0;

                comp.height = Math.round(newTemplateArea.height / this.factor);
                comp.width = Math.round(newTemplateArea.width / this.factor);
                comp.left = Math.round(left / this.factor);
                comp.top = Math.round(top / this.factor);
            }

            this.refresh();
        },
        updateTemplateArea(ev,id){
            let val = ev.target.value;
            let prop = ev.target.name;
            let scaled_val = null;
            var comp = this.getTemplateArea(id);

            if(isNaN(val) && prop !== 'name'){
                val = 1;
            }
            
            if(['width','height','top','left'].indexOf(prop) > -1){
                val = parseInt(val);
                scaled_val = val * this.factor;
            }

            if(prop == 'width' || prop == 'height'){
                val = val < 10 ? 10 : val;
            }

            if(prop == 'aspectRatio' && val == 1){
                val = ev.target.checked;
            }
            
            comp[prop] = val;

            if(scaled_val){
                comp['scaled_' + prop] = scaled_val;
            }
            
            this.setActive(comp);
            this.refresh();
        },
        parseTemplateAreas(){            
            if(this.template && this.template.templateareas){
                this.template.templateareas.map(this.scaleArea);
            }
        },
        scaleArea(ta){
            ta.scaled_height = ta.height * this.factor;
            ta.scaled_width  = ta.width * this.factor;
            ta.scaled_left   = ta.left * this.factor;
            ta.scaled_top    = ta.top * this.factor;

            return ta;
        },
        setPaperSize(){
            let id = this.template.printable_type_id;
            this.template.printable_type = this.printable_types.find(pt => pt.id == id);
            
            if(this.template.printable_type_id !== ""){
                this.setSize();
            }
        },
        refresh(){
            this.$nextTick(function(){
                this.$forceUpdate();
            })
        },
        setThumbnail(){
            let areas = this.template.templateareas;
            let canvas = this.$refs.thumbnail;
            
            let ctx = canvas.getContext('2d');

            ctx.canvas.width = this.template.printable_type.paper_width;
            ctx.canvas.height = this.template.printable_type.paper_height;

            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

            areas.forEach(area => {
                ctx.fillStyle = 'rgba(0,0,0,.2)';
                ctx.fillRect(area.left, area.top, area.width, area.height);
            });

            this.template.thumbnail = canvas.toDataURL();
        },
        async fetchData(id){
            if(id){
                this.fetchTemplate(id);
            }
            this.fetchPrintableTypes();
        },
        async fetchTemplate(id){
            const { data } = await axios.get("/api/template/" + id);
            this.template = data;

            this.$nextTick(function(){
                this.setSize();
            });
            
        },
        async fetchTemplateAreas(){
            const { data } = await axios.get("/api/templatearea");
            this.template.templateareas = data;
        },
        async fetchPrintableTypes(){
            const { data } = await axios.get("/api/printabletype");
            this.printable_types = data;
            this.refresh();
        },
        async createTemplateArea(){
            const { data } = await axios.post("/api/templatearea",{template_id:this.template.id});

            let area = this.scaleArea(data);
            this.template.templateareas.push(area);
        },
        async deleteTemplateArea(templatearea){
            if(confirm(this.$t('delete_templatearea'))){
                const { data } = await axios.delete("/api/templatearea/" + templatearea.id,templatearea);                
                this.template.templateareas = this.template.templateareas.filter(c => c.id !== templatearea.id);
            }
        },
        async saveTemplate(close){
            if(this.creating){
                const { data } = await axios.post("/api/template",this.template);
                
                this.creating = false;
                this.template = data;
                if(close){
                    this.$router.push({ path: '/admin/templates' });
                } else {
                    this.$router.push({ path: '/admin/templates/' + data.id });
                }
            } else {
                this.setThumbnail();

                const { data } = await axios.patch("/api/template/" + this.template.id,this.template);
                this.template = data;
            }

            if(close){
                this.$router.push({ path: '/admin/templates' });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
    .mt-neg-5 {
        margin-top: -0.9375rem;
        margin-bottom: -0.9375rem;
    }
    .canvas {
        border: 1px solid #ccc;
        position: relative;
    }
    .vdr {
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;
        cursor: move;
        background: rgba(0,0,0,.1);

        &.active {
            
        }
    }
    .templatearea-title {
        font-family: 'Courier New', Courier, monospace;
        font-weight: bold;
    }
    .handle {
        border:1px solid  #aaa!important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/templates/form.vue